import { Component, Input, OnChanges } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { UserService } from "@common/user/user.service";
import { VisionService } from "@org-common/lib/vision/vision.service";
import { lastValueFrom } from "rxjs";

@Component({
    selector: "adapt-personal-vision-activity-card",
    standalone: false,
    templateUrl: "./personal-vision-activity-card.component.html",
    styleUrl: "./personal-vision-activity-card.component.scss",
})
export class PersonalVisionActivityCardComponent implements OnChanges {
    @Input() public team?: Team;

    public isIntegratedVision = false;
    public constructor(
        private visionService: VisionService,
        private userService: UserService,
    ) { }

    public async ngOnChanges() {
        if (this.team) {
            const personalTeamVisions = await lastValueFrom(this.visionService.getVisionsByPersonTeam(this.userService.getCurrentPersonId(), this.team.teamId));
            this.isIntegratedVision = this.visionService.areAllVisionsCompleted(personalTeamVisions);
        }
    }

    public defineVisionForTeamForPerson(team: Team) {
        this.visionService.editVisionForPerson(this.userService.getCurrentPersonId()!, team.teamId).subscribe();
    }

    public defineIntegratedVisionForTeam(team: Team) {
        this.visionService.editIntegratedVision(team.teamId).subscribe();
    }
}
